<template>
  <section class="my-page">
    <router-view v-if="isLoggedIn"></router-view>
    <div v-else class="my-page__login">
      <LogIn routeToPage="UserInfo" />
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted, watch } from 'vue'
import { useUserStore } from '@/stores/userStore'
import { useRouter } from 'vue-router'
import LogIn from '@/components/MyPage/LogIn/LogIn.vue'

export default defineComponent({
  name: 'MyPage',
  components: {
    LogIn
  },
  setup() {
    const userStore = useUserStore()
    const router = useRouter()
    const isLoggedIn = computed(() => userStore.isLoggedIn)

    // Watch for login state changes
    watch(isLoggedIn, (newValue) => {
      if (newValue && router.currentRoute.value.path === '/min-side') {
        router.push('/min-side/profil')
      }
    })

    onMounted(() => {
      // If user is logged in and on the base /min-side route, redirect to profile
      if (isLoggedIn.value && router.currentRoute.value.path === '/min-side') {
        router.push('/min-side/profil')
      }
    })

    return {
      isLoggedIn,
    }
  },
})
</script>

<style lang="scss" scoped>
.my-page {
  display: flex;
  flex-direction: column;
  color: $clr-text;
  min-width: 50vw;
  margin-top: rem(68); //to match header height
  margin-bottom: rem(40);
  padding-right: 16px;
  padding-left: 16px;

  &__login {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem;
  }
}
</style>
